/**
 * @generated SignedSource<<2d1f8fa509068c7772039379de5725b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type RootlyIntegrationDeleteIntegrationMutation$variables = {
  input: DeleteIntegrationInput;
};
export type RootlyIntegrationDeleteIntegrationMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type RootlyIntegrationDeleteIntegrationMutation = {
  response: RootlyIntegrationDeleteIntegrationMutation$data;
  variables: RootlyIntegrationDeleteIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RootlyIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RootlyIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "65c6e158012cb91b13b6567a0c683483",
    "id": null,
    "metadata": {},
    "name": "RootlyIntegrationDeleteIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation RootlyIntegrationDeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "34e84138e68ad1739bd2b2bb4db4aa0a";

export default node;
